export default __webpack_public_path__ + "static/media/progress-third.5fe798e2.svg";